export interface MarcasEcommerce {
    articulos: number,
    destacada: string,
    imagen: string,
    marca: number,
    nombre: string,
    urlexterna: string,
}